import React from "react"
import propTypes from "prop-types"
import src from "../../images/icon-warning.svg"

const Description = ({ children, noAnswer }) => {
  return noAnswer ? (
    <div className="answer_description answer_description--no-answer">
      You haven’t answered this question yet.
      <img src={src} alt="No Answer" />
    </div>
  ) : (
    <div className="answer_description">{children}</div>
  )
}

Description.propTypes = {
  children: propTypes.oneOfType([propTypes.node, propTypes.string]),
  noAnswer: propTypes.bool
}

Description.defaultProps = {
  noAnswer: false,
  children: ""
}

export default Description
